import { batch, computed, signal } from '@preact/signals-react'

import { AGGREGATION_PRICE } from '../@constants'
import {
    acriss,
    bookingRange,
    categories,
    currency,
    dailyPrice,
    dateRange,
    fuelPolicy,
    groupBy,
    howToGroup,
    insurance,
    inTerminal,
    isPreviousComparison,
    lengthRental,
    mileage, officeGroup,
    offices,
    officesPickoff,
    prepaid,
    providers, siteGroup,
    sites,
    tiers,
    timeToCompare,
    transmission,
    webSuppliers,
    yearlyComp,
} from '@signals'
import { formatDate, stringToDate } from '@ui-seeker/utils'


export const BIFilters = signal({})
export const BITableData = signal({})
export const BIChartData = signal({})
export const BIAggregationPrice = signal(AGGREGATION_PRICE.MIN)
export const BIShowByPrice = signal(AGGREGATION_PRICE.MIN)
export const BIIsLoadingChart = signal(false)
export const BIIsLoadingTable = signal(false)
export const BIShowChartLegend = signal(false)
export const BIChartLegendVisibility = signal([])
export const BIOpenUrlModal = signal(null)
export const BIUrlId = signal(null)
export const BIUrlOptions = signal([])
export const BISelectedOffice = signal(null)
export const BISelectedOfficeOptions = signal([])
export const BIIs3DTable = signal(false)
export const BIHeaders = signal([])
export const BISubHeaders = signal([])
export const BI3DTableData = signal({})
export const BIGroupingHeader = signal(null)


export const clearBISignals = () => batch(() => {
	BIFilters.value = {}
	BITableData.value = {}
	BIChartData.value = {}
	BIIsLoadingChart.value = false
	BIIsLoadingTable.value = false
	BIShowChartLegend.value = false
	BIChartLegendVisibility.value = []
})


export const BIFormData = computed(() => ({
    siteGroupID: siteGroup.value,
	siteID: sites.value,
	officePickupID: offices.value,
    officeGroupID: officeGroup.value,
	officeDropoffID: officesPickoff.value,
	startPickupDate: formatDate(dateRange.value[0] || new Date(), { format: 'yyyyMMdd' }),
	endPickupDate: formatDate(dateRange.value[1] || new Date(), { format: 'yyyyMMdd' }),
	startBookingDate: formatDate(bookingRange.value[0] || new Date(), { format: 'yyyyMMdd' }),
	endBookingDate: formatDate(bookingRange.value[1] || new Date(), { format: 'yyyyMMdd' }),
	lor: lengthRental.value,
	currency: currency.value,
	isPreviousComparison: isPreviousComparison.value,
	periodComp: timeToCompare.value ? {
		type: yearlyComp.value ? 'year' : 'day',
		quantity: timeToCompare.value,
	} : {},
	reportType: howToGroup.value,
	tiers: tiers.value,
	providerID: providers.value,
	webSupplierID: webSuppliers.value,
	categoryID: categories.value,
	acriss: acriss.value,
	unlimited_km: mileage.value,
	insurance: insurance.value,
	is_prepaid: prepaid.value,
	fuelPolicyID: fuelPolicy.value,
	automatic: transmission.value,
	in_terminal_pickup: inTerminal.value,
	isDailyPrice: dailyPrice.value,
	groupBy: groupBy.value,
	isNewVersion: true,
	urlId: BIUrlId.value,
	officePickupIDAux: BISelectedOffice.value
}))

export const setFormData = info => {
	batch(() => {
        siteGroup.value = info.siteGroupID
		sites.value = info.siteID
		offices.value = info.officePickupID
        officeGroup.value = info.officeGroupID
		officesPickoff.value = info.officeDropoffID
		dateRange.value = [stringToDate(info.startPickupDate), stringToDate(info.endPickupDate)]
		bookingRange.value = [stringToDate(info.startBookingDate), stringToDate(info.endBookingDate)]
		lengthRental.value = info.lor
		currency.value = info.currency
		isPreviousComparison.value = info.isPreviousComparison
		timeToCompare.value = info.periodComp?.quantity || null
		yearlyComp.value = info.periodComp?.type === 'year'
		howToGroup.value = info.reportType
		tiers.value = info.tiers
		providers.value = info.providerID
		webSuppliers.value = info.webSupplierID
		categories.value = info.categoryID
		acriss.value = info.acriss
		mileage.value = info.unlimited_km
		insurance.value = info.insurance
		prepaid.value = info.is_prepaid
		fuelPolicy.value = info.fuelPolicyID
		transmission.value = info.automatic
		inTerminal.value = info.in_terminal_pickup
		dailyPrice.value = info.isDailyPrice
		groupBy.value = info.groupBy
		BIUrlId.value = info.urlId
	})
}
